var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-52047020-6be8-4101-9c08-4c091ed093a0",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.98,45H29.75l.92,4.5h37.75c2.17,0,3.77,2.01,3.29,4.12l-.78,3.41c2.63,1.28,4.44,3.97,4.44,7.09,0,4.35-3.53,7.88-7.88,7.88s-7.88-3.53-7.88-7.88c0-2.2,.91-4.2,2.37-5.62h-29.48c1.46,1.43,2.37,3.42,2.37,5.62,0,4.35-3.53,7.88-7.88,7.88s-7.88-3.53-7.88-7.88c0-2.92,1.59-5.47,3.96-6.83L13.2,9H3.38c-1.86,0-3.38-1.51-3.38-3.38V3.38C0,1.51,1.51,0,3.38,0h14.42c1.6,0,2.99,1.13,3.31,2.7l1.29,6.3h55.23c2.17,0,3.77,2.01,3.29,4.12l-6.65,29.25c-.35,1.54-1.72,2.63-3.29,2.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkShop);
export default __webpack_public_path__ + "static/media/dark - shop.ccded113207df8767584d9a7106ed2a1.svg";
export { ForwardRef as ReactComponent };